module.exports = __webpack_public_path__ + "img/logo-gov-pb.5bbec5d6.png";